


import React from 'react'

function Contact() {
  return (
    <>
      <section className="section pt-5 mt-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 p-0">
                        <div className="card map border-0">
                            <div className="card-body p-0">
                                <iframe 
                                referrerPolicy="no-referrer-when-downgrade"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2674.171278586363!2d106.91915167671343!3d47.91372326671858!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5d96932a4c0f37fb%3A0x3764f9fb97a9ebc5!2sShangri-La%20Mall!5e0!3m2!1sen!2smn!4v1747050774993!5m2!1sen!2smn" style={{border: 0}}  allowFullScreen loading='lazy'></iframe>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0 order-2 order-md-1">
                        <div className="card custom-form rounded border-0 shadow p-4">
                            <form method="post" name="myForm" id="myForm" >
                                <p id="error-msg" className="mb-0"></p>
                                <div id="simple-msg"></div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Таны овог, нэр <span className="text-danger">*</span></label>
                                            <div className="form-icon position-relative">
                                                <i data-feather="user" className="fea icon-sm icons"></i>
                                                <input name="name" id="name" type="text" className="form-control ps-5" placeholder="Энд бичнэ үү..." />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Цахим шуудан <span className="text-danger">*</span></label>
                                            <div className="form-icon position-relative">
                                                <i data-feather="mail" className="fea icon-sm icons"></i>
                                                <input name="email" id="email" type="email" className="form-control ps-5" placeholder="Энд бичнэ үү..." />
                                            </div>
                                        </div> 
                                    </div>

                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">Агуулга</label>
                                            <div className="form-icon position-relative">
                                                <i data-feather="book" className="fea icon-sm icons"></i>
                                                <input name="subject" id="subject" className="form-control ps-5" placeholder="Энд бичнэ үү..." />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">Санал хүсэлт <span className="text-danger">*</span></label>
                                            <div className="form-icon position-relative">
                                                <i data-feather="message-circle" className="fea icon-sm icons clearfix"></i>
                                                <textarea name="comments" id="comments" rows="4" className="form-control ps-5" placeholder="Дэлгэрэнгүй бичнэ үү..."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-grid">
                                            <button type="submit" id="submit" name="send" className="btn btn-primary">Илгээх</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-7 col-md-6 order-1 order-md-2">
                        <div className="title-heading ms-lg-4">
                            <h4 className="mb-4">Холбоо барих мэдээлэл</h4>
                            <p className="text-muted">Бидэнтэй хамтран ажиллахыг хүсвэл дараах хаягаар холбоо барих боломжтой.</p>
                            <div className="d-flex contact-detail align-items-center mt-3">
                                <div className="icon">
                                    <i data-feather="mail" className="fea icon-m-md text-dark me-3"></i>
                                </div>
                                <div className="flex-1 content">
                                    <h6 className="title fw-bold mb-0">Цахим шуудан</h6>
                                    <a href="mailto:contact@example.com" className="text-primary">mining.intellect@gmail.com </a>
                                </div>
                            </div>
                            
                            <div className="d-flex contact-detail align-items-center mt-3">
                                <div className="icon">
                                    <i data-feather="phone" className="fea icon-m-md text-dark me-3"></i>
                                </div>
                                <div className="flex-1 content">
                                    <h6 className="title fw-bold mb-0">Холбоо барих утас</h6>
                                    <a href="tel:+152534-468-854" className="text-primary">(+976) 9911 1902</a>
                                </div>
                            </div>
                            
                            <div className="d-flex contact-detail align-items-center mt-3">
                                <div className="icon">
                                    <i data-feather="map-pin" className="fea icon-m-md text-dark me-3"></i>
                                </div>
                                <div className="flex-1 content">
                                    <h6 className="title fw-bold mb-0">Байршил</h6>
                                    <a href="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin" data-type="iframe" className="video-play-icon text-primary lightbox">Google map дээр харах</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Contact